import React, { Component } from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/images/logo.png";
import Menu from "../assets/svg/menu-light.svg";

import MenuFunc from "./Menu";

import { Helmet } from "react-helmet";

class Terms extends Component {
state = {
menuToggled: false,
};

setmenuoff = (wot) => {
this.setState({ menuToggled: wot });
};

render() {
return (
<div>
<Helmet>
<title>Conditions d'utilisation</title>
<meta
         name="description"
         content="BoxFit est l'application web ultime d'entraînement à domicile 
         avec plus de 390 vidéos d'exercices, 10 catégories d'entraînement différentes et des 
         fonctionnalités premium telles que l'historique d'entraînement et le radar de poids. BoxFit 
         vous prépare à gérer tous les WODs au Cross Fit."
          />

          <meta property="og:url" content="https://www.boxfit-fitness.com/account" />
      <meta property="og:title" content="BoxFit" />
      <meta
        property="og:description"
        content="BoxFit est l'application web ultime d'entraînement à domicile 
        avec plus de 390 vidéos d'exercices, 10 catégories d'entraînement différentes et des 
        fonctionnalités premium telles que l'historique d'entraînement et le radar de poids. BoxFit 
        vous prépare à gérer tous les WODs au Cross Fit."
      />
      <meta property="og:site_name" content="BoxFit" />
      <meta
        property="og:image"
        content="https://www.boxfit-fitness.com/images/sharer.png"
      />
      <meta property="og:type" content="profile" />
      <meta property="og:locale" content="en_US" />
    </Helmet>
    <div class="header" style={{ position: "relative" }}>
      <MenuFunc display={this.state.menuToggled} off={this.setmenuoff} />

      <div
        style={{
          zIndex: 999,
          position: "absolute",
          top: "15px",
          left: "20px",
        }}
      >
        <Link
          to={{
            pathname: "/",
            query: {
              fromMenu: true,
            },
          }}
        >
          <img src={Logo} alt="logo" style={{ maxHeight: "45px" }}></img>
        </Link>
      </div>

      <div
        style={{
          position: "absolute",
          top: "25px",
          right: "22px",
          zIndex: 999,
        }}
        onClick={() => {
          this.setmenuoff(true);
        }}
      >
        <img src={Menu} alt="logo" style={{ maxHeight: "25px" }}></img>
      </div>
    </div>

    <div
      className="Screen"
      style={{
        /*height: "800px",
        width: "450px",
        borderRadius: "20px",
        boxShadow: "2px 2px 120px rgba(255, 255, 255, 0.15)",*/
        backgroundColor: "#fff",
      }}
    >
      <div>
        <div style={{ height: "60px" }}></div>
        <div style={{ padding: "20px" }}>
        
         <h2 style={{ fontSize: "22px", color: "#333" }}>Support / Aide</h2>

              <p style={{ fontSize: "16px", color: "#333" }}>
                Si vous avez des questions sur ce service, veuillez nous contacter à support@boxfit-fitness.com ou au 09.75.18.20.32 
              </p>
        
          <h2 style={{ fontSize: "22px", color: "#333" }}>Conditions d'utilisation</h2>
          <p style={{ fontSize: "16px", color: "#333" }}>
                Adjomo Global SL (BoxFit) exploite le service BoxFit, que nous espérons que
                vous (le « Client », « Vous » ou « Votre ») utilisez. Si vous l'utilisez,
                veuillez l'utiliser de manière responsable. Sinon, nous devrons résilier
                votre compte.
              </p>

            <p style={{ fontSize: "16px", color: "#333" }}>
            Votre accès et utilisation du Service est conditionné par votre
            acceptation et votre conformité à ces conditions. Ces termes s'appliquent
            à tous les visiteurs, utilisateurs et autres personnes souhaitant accéder
            ou utiliser le Service.
          </p>

          <p style={{ fontSize: "16px", color: "#333" }}>
            En accédant ou en utilisant le Service, vous acceptez d'être lié par ces
            conditions. Si vous êtes en désaccord avec une partie de ces termes,
            vous n'avez pas la permission d'accéder au Service. 
          </p>


              <h2 style={{ fontSize: "22px", color: "#333" }}>Votre compte</h2>

              <p style={{ fontSize: "16px", color: "#333" }}>
               Vous ne pouvez pas utiliser le Service si vous êtes une personne interdite de recevoir le Service en vertu des lois des États-Unis ou d'autres pays, y compris le pays dans lequel vous résidez ou à partir duquel vous utilisez le Service. Vous ne pouvez pas utiliser le service si vous n'avez pas plus de 18 ans. Vous devez être un être humain. Les comptes créés par des méthodes automatisées ne sont pas autorisés.
              </p>

              <h2 style={{ fontSize: "22px", color: "#333" }}>
                Utilisation du service
              </h2>

              <p style={{ fontSize: "16px", color: "#333" }}>
                Vous devez fournir des informations d'inscription précises et complètes à chaque fois que vous vous inscrivez pour utiliser le Service. Vous êtes responsable de la sécurité de vos mots de passe et de toute utilisation de votre compte. Votre utilisation du Service doit être conforme à toutes les lois, réglementations et ordonnances applicables. Vous acceptez de ne pas vous livrer à des activités qui perturbent ou interrompent le Service. Vous ne pouvez pas permettre à plusieurs personnes d'utiliser le même compte ou d'accéder au Service de manière destinée à éviter des frais.
              </p>

              <h2 style={{ fontSize: "22px", color: "#333" }}>
                Frais d'utilisation du service
              </h2>

              <p style={{ fontSize: "16px", color: "#333" }}>
                Le Service peut vous être fourni gratuitement jusqu'à certaines limites ou pour une période d'essai limitée. L'utilisation au-delà de cette limite (ou après la période d'essai) nécessite l'achat de ressources ou de services supplémentaires. Pour toutes les ressources et les services achetés, nous facturerons votre carte de crédit sur une base mensuelle. Les paiements ne sont pas remboursables. Il n'y aura pas de remboursements ou de crédits pour les mois de service partiels, les remboursements de mise à niveau/retrogradation, ou les remboursements pour les mois non utilisés avec un compte ouvert. Les frais sont basés uniquement sur les mesures de votre utilisation du Service par BoxFit, sauf accord écrit contraire. Tous les frais sont exclusifs de toutes taxes, prélèvements ou droits imposés par les autorités fiscales, et vous serez responsable du paiement de tous ces taxes, prélèvements ou droits. Vous reconnaissez et acceptez que toutes les informations relatives à votre carte de crédit, à la facturation et au paiement que vous fournissez à BoxFit peuvent être partagées par BoxFit avec des sociétés travaillant au nom de BoxFit, telles que des processeurs de paiement et/ou des agences de crédit, uniquement dans le but de vérifier votre solvabilité, d'effectuer des paiements à BoxFit et de gérer votre compte. BoxFit peut modifier ses frais et politiques de paiement pour le service en vous informant au moins trente (30) jours avant le début du cycle de facturation au cours duquel cette modification prendra effet.
              </p>

              <h2 style={{ fontSize: "22px", color: "#333" }}>
                Communications
              </h2>

              <p style={{ fontSize: "16px", color: "#333" }}>
                En créant un compte sur notre service, vous acceptez de vous abonner à nos bulletins d'information, à nos supports marketing ou promotionnels et à toute autre information que nous pourrions envoyer. Toutefois, vous pouvez choisir de ne pas recevoir toutes ou certaines de ces communications de notre part en suivant le lien de désabonnement ou les instructions fournis dans chaque e-mail que nous envoyons.
              </p>

              <h2 style={{ fontSize: "22px", color: "#333" }}>
                Annulation 
              </h2>

              <p style={{ fontSize: "16px", color: "#333" }}>
                Vous devez annuler votre compte en soumettant une demande de support sur https://www.boxfit-fitness.com/support en utilisant l'adresse e-mail associée à votre compte. Toute autre demande d'annulation par e-mail ou par téléphone ne sera pas considérée comme une annulation. Aucun remboursement ne sera effectué si vous annulez votre compte. Si vous annulez le Service avant la fin du mois pour lequel vous avez déjà payé, votre annulation prendra effet immédiatement et aucun frais supplémentaire ne sera facturé. Vous acceptez que BoxFit, à sa seule discrétion et pour n'importe quelle raison ou sans raison, puisse résilier ou suspendre votre compte. Vous acceptez que toute résiliation de votre accès au Service puisse être effectuée sans préavis, et vous acceptez que BoxFit ne soit pas responsable envers vous ou envers un tiers pour une telle résiliation.

              </p>

              <h2 style={{ fontSize: "22px", color: "#333" }}>
                Idées ou retours
              </h2>

              <p style={{ fontSize: "16px", color: "#333" }}>
                Vous pouvez choisir de soumettre des commentaires ou des idées sur le Service, y compris, mais sans s'y limiter, des idées pour améliorer le Service ou nos produits ("Idées"), ou nous pouvons vous inviter à le faire. En soumettant une Idée, vous acceptez que votre divulgation est non sollicitée et sans restriction et ne placera pas BoxFit sous aucune obligation fiduciaire ou autre, et que nous sommes libres d'utiliser l'Idée sans aucune compensation supplémentaire pour vous, et/ou de divulguer l'Idée de manière non confidentielle ou autrement à quiconque.
              </p>

              <h2 style={{ fontSize: "22px", color: "#333" }}>
                Modification du Service
              </h2>

              <p style={{ fontSize: "16px", color: "#333" }}>
                Vous reconnaissez et acceptez que le Service puisse changer de temps en temps sans préavis préalable. Les changements incluent, sans s'y limiter, les modifications des politiques de frais et de paiement, les correctifs de sécurité, les fonctionnalités ajoutées ou supprimées, et autres améliorations ou restrictions. BoxFit ne sera pas responsable envers vous ou envers un tiers pour toute modification, changement de prix, suspension ou interruption du Service.
              </p>

              <h2 style={{ fontSize: "22px", color: "#333" }}>
                Liens vers les autres sites
              </h2>

              <p style={{ fontSize: "16px", color: "#333" }}>
                Notre Service peut contenir des liens vers des sites Web ou des services tiers qui ne sont pas détenus ou contrôlés par BoxFit. BoxFit n'a aucun contrôle sur le contenu, les politiques de confidentialité ou les pratiques de ces sites Web ou services tiers et n'assume aucune responsabilité à cet égard. Nous ne garantissons pas les offres de ces entités/individus ou de leurs sites Web. Vous reconnaissez et acceptez que BoxFit ne sera pas responsable ou responsable, directement ou indirectement, de tout dommage ou perte causé ou prétendument causé par ou en relation avec l'utilisation ou la confiance en tout contenu, bien ou service disponible sur ou via ces sites Web ou services tiers. Nous vous conseillons vivement de lire les termes et conditions et les politiques de confidentialité de tout site Web ou service tiers que vous visitez.
              </p>

              <h2 style={{ fontSize: "22px", color: "#333" }}>
                Indemnité
              </h2>

              <p style={{ fontSize: "16px", color: "#333" }}>
                Vous acceptez de défendre, d'indemniser et de tenir indemne BoxFit et ses licenciés et concédants de licence, ainsi que leurs employés, sous-traitants, agents, dirigeants et administrateurs, de toute réclamation, dommage, obligation, perte, responsabilité, coût ou dette et dépenses (y compris, mais sans s'y limiter, les honoraires d'avocat), résultant de ou découlant de a) votre utilisation et accès au Service, par vous ou toute personne utilisant votre compte et mot de passe ; b) une violation de ces Conditions.
              </p>

              <h2 style={{ fontSize: "22px", color: "#333" }}>
                Exclusion de garanties
              </h2>

              <p style={{ fontSize: "16px", color: "#333" }}>
                SI VOUS ACCÉDEZ AU SERVICE, VOUS LE FAITES À VOS PROPRES RISQUES. NOUS FOURNISSONS LE SERVICE "TEL QUEL", "AVEC TOUS LES DÉFAUTS" ET "TEL QUE DISPONIBLE". NOUS NE DONNONS AUCUNE GARANTIE EXPRESSE OU IMPLICITE CONCERNANT LE SERVICE. DANS LA MESURE MAXIMALE PERMISE PAR LA LOI, NOUS REJETONS PAR LA PRÉSENTE TOUTES CES GARANTIES, Y COMPRIS TOUTES LES GARANTIES STATUTAIRES, EN CE QUI CONCERNE LE SERVICE, Y COMPRIS, SANS LIMITATION, TOUTES LES GARANTIES QUE LE SERVICE EST MARCHAND, DE QUALITÉ SATISFAISANTE, PRÉCIS, ADAPTÉ À UN USAGE PARTICULIER OU AUX BESOINS, OU NON CONTREFAISANT. NOUS NE GARANTISSONS PAS QUE LES RÉSULTATS QUI PEUVENT ÊTRE OBTENUS PAR L'UTILISATION DU SERVICE SERONT EFFICACES, FIABLES OU PRÉCIS, OU QU'ILS RÉPONDRONT À VOS EXIGENCES. NOUS NE GARANTISSONS PAS QUE VOUS POURREZ ACCÉDER OU UTILISER LE SERVICE (SOIT DIRECTEMENT SOIT PAR LE BIAIS DE RÉSEAUX TIERS) AUX HEURES OU AUX ENDROITS DE VOTRE CHOIX. NOUS NE SOMMES PAS RESPONSABLES DE L'EXACTITUDE, DE LA FIABILITÉ, DE LA PONCTUALITÉ OU DE L'EXHAUSTIVITÉ DES INFORMATIONS FOURNIES PAR D'AUTRES UTILISATEURS DU SERVICE OU DE TOUTE AUTRE DONNÉE OU INFORMATION FOURNIE OU REÇUE PAR LE SERVICE. SAUF INDICATION CONTRAIRE EXPRESSEMENT DÉFINIE ICI, BOXFIT NE FOURNIT AUCUNE GARANTIE CONCERNANT LES SYSTÈMES D'INFORMATION, LE LOGICIEL ET LES FONCTIONS ACCESSIBLES PAR OU À TRAVERS LE SERVICE, OU TOUTE SÉCURITÉ ASSOCIÉE À LA TRANSMISSION D'INFORMATIONS SENSIBLES. BOXFIT NE GARANTIT PAS QUE LE SERVICE SERA FONCTIONNEZ SANS ERREUR, QUE LES ERREURS DANS LE SERVICE SERONT CORRIGÉES, QUE LA PERTE DE DONNÉES NE SE PRODUIRA PAS, OU QUE LE SERVICE OU LES LOGICIELS SONT EXEMPTS DE VIRUS INFORMATIQUES, CONTAMINANTS OU AUTRES ARTICLES NOCIFS. EN AUCUN CAS BOXFIT, AUCUN DE NOS AFFILIÉS, DISTRIBUTEURS, PARTENAIRES, CONCÉDANTS DE LICENCE ET/OU L'UN DE NOS OU LEURS ADMINISTRATEURS, DIRIGEANTS, EMPLOYÉS, CONSULTANTS, AGENTS OU LES AUTRES REPRÉSENTANTS SERONT RESPONSABLES DE TOUTE PERTE OU DOMMAGE CAUSÉ PAR VOTRE CONFIANCE AUX INFORMATIONS OBTENUES VIA LE SERVICE.
              </p>

              <h2 style={{ fontSize: "22px", color: "#333" }}>
                Limitations de responsabilité
              </h2>

              <p style={{ fontSize: "16px", color: "#333" }}>
                En aucun cas, BoxFit, ni ses directeurs, employés, partenaires, agents, fournisseurs ou affiliés ne pourront être tenus responsables de dommages indirects, accessoires, spéciaux, consécutifs ou punitifs, y compris, sans s'y limiter, la perte de bénéfices, de données, d'utilisation, de bonne volonté ou d'autres pertes immatérielles, résultant de (i) votre accès à ou l'utilisation ou l'incapacité d'accéder à ou d'utiliser le Service; (ii) tout comportement ou contenu de tout tiers sur le Service; (iii) tout contenu obtenu à partir du Service; et (iv) l'accès non autorisé, l'utilisation ou l'altération de vos transmissions ou de votre contenu, que ce soit fondé sur la garantie, le contrat, le délit (y compris la négligence) ou toute autre théorie juridique, que nous ayons été informés ou non de la possibilité de tels dommages, et même si un recours énoncé dans le présent document est jugé avoir échoué dans son but essentiel.
              </p>

              <h2 style={{ fontSize: "22px", color: "#333" }}>
                Choix de la loi et règlement des différends
              </h2>

              <p style={{ fontSize: "16px", color: "#333" }}>
                Ces termes seront régis et interprétés conformément aux lois du Royaume-Uni, sans égard à ses dispositions en matière de conflit de lois. Notre non-exercice de tout droit ou disposition de ces termes ne sera pas considéré comme une renonciation à ces droits. Si une disposition de ces termes est jugée invalide ou inapplicable par un tribunal, les dispositions restantes de ces termes resteront en vigueur. Ces termes constituent l'accord complet entre nous en ce qui concerne notre service et remplacent tout accord antérieur que nous aurions pu avoir entre nous concernant le service.
              </p>

             
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Terms;
